var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5625 3.75V13.875C22.5625 15.7734 21.0332 17.25 19.1875 17.25H12.4375L6.68945 20.5195C6.53125 20.625 6.42578 20.625 6.32031 20.625C5.95117 20.625 5.6875 20.4141 5.6875 19.9922V17.25H4C2.10156 17.25 0.625 15.7734 0.625 13.875V3.75C0.625 1.9043 2.10156 0.375 4 0.375H19.1875C21.0332 0.375 22.5625 1.9043 22.5625 3.75ZM8.21875 16.7754L11.752 14.7188H19.1875C19.6094 14.7188 20.0312 14.3496 20.0312 13.875V3.75C20.0312 3.32812 19.6094 2.90625 19.1875 2.90625H4C3.52539 2.90625 3.15625 3.32812 3.15625 3.75V13.875C3.15625 14.3496 3.52539 14.7188 4 14.7188H8.21875V16.7754ZM14.125 20.625V18.9375H16.6562V20.625C16.6562 21.0996 17.0254 21.4688 17.5 21.4688H23.1953L26.7812 23.5254V21.4688H31C31.4219 21.4688 31.8438 21.0996 31.8438 20.625V10.5C31.8438 10.0781 31.4219 9.65625 31 9.65625H24.25V7.125H31C32.8457 7.125 34.375 8.6543 34.375 10.5V20.625C34.375 22.5234 32.8457 24 31 24H29.3125V26.7422C29.3125 27.1641 28.9961 27.375 28.6797 27.375C28.5215 27.375 28.416 27.375 28.2578 27.2695L22.5625 24H17.5C15.6016 24 14.125 22.5234 14.125 20.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.5018e3cb090c68efced1091567330c29.svg";
export { ForwardRef as ReactComponent };